














import { Vue, Component, Prop } from 'vue-property-decorator';
@Component
export default class StatisticCardIcon extends Vue {
  @Prop({ required: true, type: String })
  title!: string;
  @Prop({ required: true, type: String })
  value!: string;
  @Prop({ required: true, type: String })
  avatarBgColor!: string;
}
